module.exports = __webpack_public_path__ + "img/5.8dbd065a.png";